import styled from "@emotion/styled";
import { Skeleton } from "@kaltura/mediaspace-shared-styled";
import { useTheme } from "@mui/material";
import { useMediaQuery } from "@kaltura/mediaspace-shared-utils";

const StyledChannelResult = styled("div")(({ theme }) => ({
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
}));

const StyledChannelResultLinkSkeleton = styled(Skeleton)(({ theme }) => ({
    marginTop: theme.spacing(1),
    borderRadius: theme.kaltura.shape.roundness1,
    height: theme.spacing(2),
}));

const ChannelResultSkeleton = () => {
    return (
        <StyledChannelResult>
            <Skeleton variant="circular" width={100} height={100} />
            <StyledChannelResultLinkSkeleton variant="rectangular" width={100} />
            <StyledChannelResultLinkSkeleton variant="rectangular" width={60} />
        </StyledChannelResult>
    );
};

const StyledChannelResults = styled("div")(({ theme }) => ({
    marginBottom: theme.spacing(2),
    display: "flex",
    justifyContent: "space-between",
}));

/**
 * global search results skeleton - channel results
 */
export const ChanneResultsSkeleton = () => {
    const theme = useTheme();
    const sm = useMediaQuery(theme.breakpoints.up("sm"));
    const md = useMediaQuery(theme.breakpoints.up("md"));
    const lg = useMediaQuery(theme.breakpoints.up("lg"));

    return (
        <>
            <StyledChannelResults>
                <ChannelResultSkeleton />
                <ChannelResultSkeleton />
                <ChannelResultSkeleton />
                {sm && <ChannelResultSkeleton />}
                {md && <ChannelResultSkeleton />}
                {md && <ChannelResultSkeleton />}
                {lg && <ChannelResultSkeleton />}
            </StyledChannelResults>
        </>
    );
};
